/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Price_Lower_Not_SentInputs */

const en_admin_external_booking_edit_price_lower_not_sent = /** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Updating this booking will decrease its price. A credit note will be automatically generated.`)
};

const de_admin_external_booking_edit_price_lower_not_sent = /** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn du diese Buchung aktualisierst, sinkt ihr Preis. Eine Gutschrift wird automatisch erstellt.`)
};

const es_admin_external_booking_edit_price_lower_not_sent = /** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar esta reserva disminuirá su precio. Se generará automáticamente una nota de crédito.`)
};

const fr_admin_external_booking_edit_price_lower_not_sent = /** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La modification de cette réservation diminuera son prix. Une note de crédit sera automatiquement générée.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */
const it_admin_external_booking_edit_price_lower_not_sent = en_admin_external_booking_edit_price_lower_not_sent;

/** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_price_lower_not_sent = en_admin_external_booking_edit_price_lower_not_sent;

/** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */
const pl_admin_external_booking_edit_price_lower_not_sent = en_admin_external_booking_edit_price_lower_not_sent;

/** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */
const hu_admin_external_booking_edit_price_lower_not_sent = en_admin_external_booking_edit_price_lower_not_sent;

/** @type {(inputs: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs) => LocalizedString} */
const ro_admin_external_booking_edit_price_lower_not_sent = en_admin_external_booking_edit_price_lower_not_sent;

/**
* | output |
* | --- |
* | "Updating this booking will decrease its price. A credit note will be automatically generated." |
*
* @param {Admin_External_Booking_Edit_Price_Lower_Not_SentInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_price_lower_not_sent = /** @type {((inputs?: Admin_External_Booking_Edit_Price_Lower_Not_SentInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Price_Lower_Not_SentInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "de") return de_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "es") return es_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "it") return it_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_price_lower_not_sent(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_price_lower_not_sent(inputs)
	return ro_admin_external_booking_edit_price_lower_not_sent(inputs)
});
export { admin_external_booking_edit_price_lower_not_sent as "admin.external_booking_edit.price_lower_not_sent" }